const WEBSITE_URL_REGEX =
  /^(https?:\/\/)?([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(:\d{1,5})?([/?#]\S*)?$/i;

export const isValidWebsite = (value: string): boolean =>
  WEBSITE_URL_REGEX.test(value.trim());
